import { CategoryTypes } from './enums/categoryTypes';
import { EcommerceClient } from './models/ecommerceClient';
import { EcommerceObject } from './models/ecommerceObject';
import { Product } from './models/ecommerceProduct';
import { GoogleAds } from './models/ecommerceGoogleAds';

export class EcommerceComponent {
    constructor() {
        this.ecommerceObject.ecommerce = {
            currencyCode: 'USD',
            purchase: {
                actionField: {
                    id: '',
                    revenue: 0,
                    coupon: this.promoAlias
                },
                products: []
            }
        };
    }

    private promoAlias = '';
    private forceDebug = false;
    private ecommerceObject = new EcommerceObject();
    private client: EcommerceClient;

    public setPromo(promo: string): EcommerceComponent {
        this.promoAlias = promo;
        this.ecommerceObject.ecommerce.purchase.actionField.coupon = promo;
        return this;
    }

    public setDebug(isDebug: boolean): EcommerceComponent {
        this.forceDebug = isDebug;
        return this;
    }

    public setDealer(dealer: string): EcommerceComponent {
        this.ecommerceObject.dealerName = dealer;
        return this;
    }

    public setTransaction(transactionId: string): EcommerceComponent {
        this.ecommerceObject.ecommerce.purchase.actionField.id = transactionId;
        return this;
    }

    public setClient(client: EcommerceClient): EcommerceComponent {
        this.client = client;
        this.ecommerceObject.customerNew = client.id ? 'Customer Existing' : 'Customer New';
        this.ecommerceObject.userId = client.readableId;
        this.ecommerceObject.customerProvince = client.provinceName;
        this.ecommerceObject.customerCountry = client.countryName;
        this.ecommerceObject.сustomerType = client.isLegacy ? 'Legacy' : 'Regular';
        this.ecommerceObject.paymentType = 'Credit Card';
        return this;
    }

    public setCustomerNew(): EcommerceComponent {
        this.ecommerceObject.customerNew = 'Customer New';
        return this;
    }

    public addProduct(element: Product, count: number) {
        element.quantity = count;
        element.coupon = this.promoAlias;

        if (element.category === CategoryTypes.Shipping) {
            element.name = `Доставка (${this.client.countryName})`;
        };

        this.ecommerceObject.ecommerce.purchase.products.push(element);
    }

    public setGoogleAds(googleAds: GoogleAds): EcommerceComponent {
        this.ecommerceObject.googleAds = googleAds;
        return this;
    }

    /**
     * Send data to GA
     * @param isTrial Is Trial Flag
     */
    public send(isTrial: boolean, transactionType: string) {
        this.ecommerceObject.dealerName = '';
        this.ecommerceObject.isTrial = isTrial ? 'true' : 'false';

        this.ecommerceObject.event = 'purchase';
        this.ecommerceObject.customerSource = 'online';
        this.ecommerceObject.transactionType = transactionType;

        let totalSum = 0;
        this.ecommerceObject.ecommerce.purchase.products.forEach(e => {
            totalSum += Number(e.dimension2);
        });

        this.ecommerceObject.ecommerce.purchase.actionField.revenue = totalSum;
        this.ecommerceObject.debug =
            this.forceDebug.toString() || (this.client.firstName === 'John' && this.client.lastName === 'Rambo').toString();

        const object = Object.assign({}, this.ecommerceObject);
        (window as any)['dataLayer'].push(object);
    }

    public setCallback(fn: () => void) {
        this.ecommerceObject.eventCallback = fn;
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/ecommerce/ecommerce.ts